import script from "./CollisionSimulator.vue?vue&type=script&setup=true&lang=js"
export * from "./CollisionSimulator.vue?vue&type=script&setup=true&lang=js"

import "./CollisionSimulator.vue?vue&type=style&index=0&id=1e10265a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e10265a"]])

export default __exports__